import { State, Action, StateContext } from '@ngxs/store';
import { catchError, tap } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { ApiGetStockAction, ApiGetStockActionErrorAction, ApiGetStockActionSuccessAction } from './warehouse.actions';
import { LogisticsService } from '../../services/logistics.service';
import { NotificationService } from '@core/services/notification.service';

enum ErrorMessages {
  StockInfoError = 'Noe gikk galt ved henting av lagerstatus for varer.',
}

export interface WarehouseStateModel {
  // key: offeringId, value: quantity in stock
  quantityInStock: Record<string, number>;
}

@State<WarehouseStateModel>({
  name: 'warehouse',
  defaults: {
    quantityInStock: {},
  },
})
@Injectable()
export class WarehouseState {
  private logisticsService = inject(LogisticsService);
  private notificationService = inject(NotificationService);

  @Action(ApiGetStockAction)
  public apiGetStockAction({ dispatch }: StateContext<WarehouseStateModel>, { offeringIds }: ApiGetStockAction) {
    if (!offeringIds || offeringIds.length === 0) {
      return;
    }

    return this.logisticsService.getStockInfoMultipleOfferings(offeringIds).pipe(
      tap(response => dispatch(new ApiGetStockActionSuccessAction(response))),
      catchError(() => dispatch(new ApiGetStockActionErrorAction()))
    );
  }

  @Action(ApiGetStockActionSuccessAction)
  public apiGetStockActionSuccessAction(
    { getState, patchState }: StateContext<WarehouseStateModel>,
    { response }: ApiGetStockActionSuccessAction
  ) {
    const updatedStock: Record<string, number> = { ...getState().quantityInStock };
    response.stockItems.map(stockItem => (updatedStock[stockItem.offeringId] = stockItem.quantity));

    patchState({
      quantityInStock: updatedStock,
    });
  }

  @Action(ApiGetStockActionErrorAction)
  public apiGetStockActionErrorAction() {
    this.notificationService.warn(ErrorMessages.StockInfoError);
  }
}
